import { render, staticRenderFns } from "./WalletHistories.vue?vue&type=template&id=146ea9bc"
import script from "./WalletHistories.vue?vue&type=script&lang=ts"
export * from "./WalletHistories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports